/**
 * Courtesy of StackOverflow
 * https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid
 *
 * @description The originally used function wouldn't work nicely in our
 * case as this webpack version would strip crypto for some reason:
 *
 * function uuid4() {
 *   return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
 *     (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
 *   );
 * }
 */
export function uuid4 (): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
